export const getAuthDomain = (auth: { domain: string; oldDomain?: string }): string =>
  auth.oldDomain && window.location.hostname.endsWith('jobcloud.ai') ? auth.oldDomain : auth.domain;
